/*
 * MONEY - the one price formatter of the browser code (cart, orders, search, order dialog).
 * The theme's price rules come from its config.json ("money") as window.MONEY_FORMAT - the same
 * rules the server applies (App\Helpers\MoneyFormat):
 *   group: "nbsp"             thousands separated by a non-breaking space in every language
 *                             (four-digit amounts too)
 *   trim_zero_decimals: true  a whole amount has no decimals
 * No rules = the locale's own format.
 */
const Money = {
    rules() {
        return window.MONEY_FORMAT || {};
    },
    locale() {
        const lan = window.lan || document.documentElement.lang || 'en';
        return lan === 'en' ? 'en-US' : (lan.length === 2 ? lan + '-' + lan.toUpperCase() : lan);
    },
    decimals(amount, currency) {
        const whole = Math.abs(Number(amount) - Math.round(Number(amount))) < 0.005;
        return currency === 'HUF' || (this.rules().trim_zero_decimals && whole) ? 0 : 2;
    },
    format(amount, currency) {
        const n = Number(amount);
        if (amount === null || amount === undefined || amount === '' || !Number.isFinite(n)) return '';
        const code = currency || (typeof window.currency === 'string' ? window.currency : '');
        const digits = this.decimals(n, code);
        const nbsp = this.rules().group === 'nbsp';
        try {
            const formatter = new Intl.NumberFormat(this.locale(), {
                style: code ? 'currency' : 'decimal',
                ...(code ? { currency: code } : {}),
                minimumFractionDigits: digits,
                maximumFractionDigits: digits,
                // "always": the four-digit amounts are grouped too (Hungarian leaves them out)
                ...(nbsp ? { useGrouping: 'always' } : {}),
            });
            if (!nbsp) return formatter.format(n);
            return formatter.formatToParts(n).map((p) => (p.type === 'group' ? ' ' : p.value)).join('');
        } catch (e) {
            return n + (code ? ' ' + code : '');
        }
    },
};

window.Money = Money;
